import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Swal from "sweetalert2";
import { Helmet } from "react-helmet-async";
import Select from "react-select";

const RefPembelajaan = () => {
    const [kelas, setKelas] = useState([]); // State untuk menyimpan daftar kelas
    const [guru, setGuru] = useState([]); // State untuk menyimpan daftar kelas
    const [mapel, setmapel] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        rombongan_belajar_id:"",
        mata_pelajaran_id:"",
        guru_id:"",
        jumlah_jam:"",
        jam_minimum:""

    });
    const [isEditing, setIsEditing] = useState(false);
   


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData)

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputPembelajaran`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                   
                },
                credentials: 'include',
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();
            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            setError('');
        } catch (error) {
             Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
           
            setError(error.response?.data?.message || 'Something went wrong');
        }
    };

    const handleEdit = (ujian) => {console.log(ujian)
        setIsEditing(true);
        setFormData({ ...ujian, jam_minimum:ujian.jam_minimum || 0,jumlah_jam:ujian.jumlah_jam ||0 });
    };

    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            rombongan_belajar_id:"",
            mata_pelajaran_id:"",
            guru_id:""
    
        })
      
    };
   
    useEffect(() => {
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
        
    
        const table = $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getPembelajaran`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    
                },
              xhrFields: {
      withCredentials: true, // agar cookie/session dikirim kalau pakai credentials
    },
                dataSrc: function(json) {
                    if (!json.data.pembelajaran || json.data.pembelajaran.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    return json.data.pembelajaran;
                }
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama_rombel}</b>`;
                    }
                },
                { data: "nama_mapel"||"-" },
                { data: "nama_guru"||"-" },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.jumlah_jam||"-"}</b> (${data.jam_minimum||"-"})`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                            
                            <div class="btn-group">
  <button 
    class="btn btn-light btn-sm dropdown-toggle" 
    type="button" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style="border: none;">
    <i class="ti ti-dots-vertical"></i>
  </button>
  <ul class="dropdown-menu dropdown-menu-end">
    <li>
      <a 
        href="#" 
        class="dropdown-item edit-btn" 
        data-bs-toggle="modal" 
        data-bs-target="#ujianModal" 
        data-row='${JSON.stringify(row)}'>
        <i class="ti ti-edit me-2"></i> Ubah
      </a>
    </li>
    <li>
      <a 
        href="#" 
        class="dropdown-item delete-btn text-danger" 
        data-id="${row.pembelajaran_id}">
        <i class="ti ti-trash me-2"></i> Hapus
      </a>
    </li>
  </ul>
</div>

                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });
    
        // Event DataTables setelah data Ajax diterima
        $('.table').on('xhr.dt', function (e, settings, json) {
            if (json && json.data && json.data.guru) {
                setGuru(json.data.guru);  // Memperbarui state dengan data guru
            }
            if (json && json.data && json.data.rombel) {
                setKelas(json.data.rombel);  // Memperbarui state dengan data guru
            }
            if (json && json.data && json.data.mapel) {
                setmapel(json.data.mapel);  // Memperbarui state dengan data guru
            }
        });
    
        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []); // Tambahkan setGuru sebagai dependency
    

    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapuspembelajaran`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                       
                    },
                    credentials: 'include',
                    body: JSON.stringify({ pembelajaran_id : id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    const handleChangeSelectedRombel = (selectedOptions, name, text) => {
        if (!selectedOptions) return;
    
        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: selectedOptions.rombel_id ? selectedOptions.rombel_id.toString() : null,
                [text]: selectedOptions.nama_rombel || null
            };
    
            console.log("Updated Form Data:", updatedData);
            return updatedData;
        });
    };
    
    const handleChangeSelectedMapel = (selectedOptions,name,text) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            [name]: selectedData.id_mapel ? selectedData.id_mapel?.toString() : null, // Perbaiki agar langsung pakai `selectedData`
            [text]: selectedData.nama_mapel ? selectedData.nama_mapel : null
        }));

        console.log("Updated Form Data:", formData);
    }; 
    const handleChangeSelectedGuru = (selectedOptions,name,text) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            [name]: selectedData.data_id ? selectedData.data_id?.toString() : null, // Perbaiki agar langsung pakai `selectedData`
            [text]: selectedData.nama ? selectedData.nama : null
        }));

        console.log("Updated Form Data:", formData);
        console.log(formData.guru_id)
    };

    
    return (
        <>
            <Helmet>
                <title>Refrensi - Pembelajaran - Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Refrensi Pembelajaran / Guru Mengajar pada mapel dan kelas</h3></div>

                                            <div className='col-auto'>
                                                  <button
                                                    type="button"
                                                    className="btn btn-info d-inline-flex align-items-center"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#ujianModal"
                                                    onClick={handleNew}
                                                >
                                                    <i className="ti ti-plus me-2"></i>
                                                    Data Baru
                                                </button>
                                                </div>
                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table" >
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th width="50">Kelas</th>
                                                    <th width="50"><center>Pelajaran</center></th>
                                                    <th scope="col">Guru</th>
                                                    <th scope="col">Jumlah Jam (Jam Minimal Harian)</th>
                                                    <th width="50"><center>Action</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                               
                                            </tbody>
                                        </table>
                                        {/* Tampilkan error jika ada */}
                                        {error && <div className="alert alert-danger">{error}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Input/Edit */}
                <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                        <form onSubmit={handleSubmit} className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? "Edit Pembelajaran" : "Tambah Pembelajaran"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Kelas / Rombel</label>
                                    <Select
                                    options={kelas || []}
                                    required
                                    name="rombongan_belajar_id"
                                    getOptionLabel={(e) => e.nama_rombel} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.rombel_id } // Menggunakan `data_id` sebagai value
                                    value={kelas.find((option) => option?.rombel_id?.toString() === formData?.rombongan_belajar_id?.toString()) || null}
                                    onChange={(selectedOption) => handleChangeSelectedRombel(selectedOption, "rombongan_belajar_id","nama_rombel")}
                                    placeholder="Pilih Kelas / Rombel..."
                                />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Mata Pelajaran</label>
                                    <Select
                                    options={mapel || []}
                                    required
                                    name="mata_pelajaran_id"
                                    getOptionLabel={(e) => e.nama_mapel} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.id_mapel } // Menggunakan `data_id` sebagai value
                                    value={mapel.find((option) => option?.id_mapel?.toString() === formData?.mata_pelajaran_id?.toString()) || null}
                                    onChange={(selectedOption) => handleChangeSelectedMapel(selectedOption, "mata_pelajaran_id","nama_mapel")}
                                    placeholder="Pilih Mapel / Mata Pelajaran..."
                                />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Guru</label>
                                    <Select
                                    options={guru || []}
                                    required
                                    name="guru_id"
                                    getOptionLabel={(e) => e.nama} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.data_id } // Menggunakan `data_id` sebagai value
                                    value={guru.find((option) => option?.data_id?.toString() === formData?.guru_id?.toString()) || null}
                                    onChange={(selectedOption) => handleChangeSelectedGuru(selectedOption, "guru_id","nama_guru")}
                                    placeholder="Pilih Guru..."
                                />
                                </div>

                                <div className="mb-3">
                                <label className="form-label">Jumah Jam / 1 Minggu</label>
                                <input type="number" className="form-control" name="jumlah_jam" value={formData?.jumlah_jam || 0} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Jam Minimal / Hari</label>
                                <input type="number" className="form-control" name="jam_minimum" value={formData?.jam_minimum || 0} onChange={handleChange} required />

                            </div>

                               
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Batal
                                </button>
                                <button type="onSubmit" className="btn btn-primary" data-bs-dismiss="modal">
                                    {isEditing ? "Update" : "Simpan"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
};

export default RefPembelajaan;
